import ProgramSkeleton from './ProgramSkeleton';

export default function ProgramPageSkeleton() {
    return (
        <div className="mt-2 w-full max-w-[1200px] mx-auto px-4 md:px-12 animate-pulse">
            {/* Banner */}
            <div className="w-full h-32 bg-gray-200 rounded-xl" />

            {/* Header: avatar + title */}
            <div className="flex items-start mb-6 px-6">
                <div className="-mt-10 mr-4 md:-mt-12 md:mr-6">
                    <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-gray-200 border-4 border-white" />
                </div>
                <div className="mt-2 md:mt-3">
                    <div className="h-8 w-64 bg-gray-200 rounded" />
                </div>
            </div>

            {/* Two-column layout */}
            <div className="pt-4 grid grid-cols-1 md:grid-cols-[1fr_312px] gap-6">
                {/* Left: requirement sections */}
                <div>
                    {[0, 1, 2].map(i => (
                        <ProgramSkeleton key={i} showBadge={false} />
                    ))}
                </div>

                {/* Right: sidebar */}
                <div className="hidden md:block bg-gray-50 rounded-md p-3">
                    <div className="border-b border-gray-200 pb-4">
                        <div className="h-4 w-40 bg-gray-200 rounded mb-2" />
                        <div className="h-3 w-28 bg-gray-100 rounded" />
                        <div className="mt-4 space-y-1.5">
                            <div className="flex justify-between">
                                <div className="h-3 w-32 bg-gray-100 rounded" />
                                <div className="h-3 w-8 bg-gray-100 rounded" />
                            </div>
                            <div className="h-1.5 w-full bg-gray-200 rounded-full" />
                        </div>
                    </div>
                    <div className="pt-2">
                        <div className="h-3 w-24 bg-gray-200 rounded mb-2" />
                        <div className="flex flex-col gap-0.5 py-2">
                            {[0, 1, 2, 3, 4, 5, 6, 7].map(i => (
                                <div key={i} className="flex items-center gap-2 px-2 py-1.5">
                                    <div className="w-3.5 h-3.5 rounded-full bg-gray-200 flex-shrink-0" />
                                    <div className="h-3 bg-gray-100 rounded" style={{ width: `${60 + (i % 3) * 15}%` }} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
